import Vue from "vue";

import mUtils from "@/modules/utils";
//import { APP_MODE } from "@/modules/enums";
import { ORDER_TYPE } from "@/modules/enums";

export default {
  state: {
    stores: {
      header: "",
      list: [],
      sortBy: "distance",
      addShortcutBarEnabled: false,
    },
    store: null,
    allowedOrderHours: [],
  },

  getters: {
    storesSortList: state => {
      let list = [];

      if (state.stores.list.length > 1) {
        list = ["distance", "alphabetic"];
        if (state.stores.sortBy == "customize") list.push(state.stores.sortBy);
      }

      return list;
    },

    storeCompanyCode: state => {
      if (state.store) return state.store.companyCode;
      else return null;
    },

    storeInfo: state => {
      if (state.store) return state.store.info;
      else return null;
    },

    storeService: state => {
      if (state.store) return state.store.service;
      else return null;
    },

    storeLinked: state => {
      return state.store?.linked;
    },

    storeConfig: state => {
      if (state.store) return state.store.config;
      else return null;
    },

    storeCheckout: state => {
      if (state.store) return state.store.checkout;
      else return null;
    },

    storeID: (state, getters) => {
      let ID = "";
      if (getters.storeInfo) ID = getters.storeInfo.storeID;

      return ID;
    },

    storeLogoUrl: (state, getters, rootState) => {
      let imageUrl = "";
      if (rootState.appData?.type == "membership") {
        if (getters.storeLinked && Array.isArray(getters.storeLinked)) {
          getters.storeLinked.forEach(x => {
            if (x.type == "M" && x.Image?.FileSize > 0) {
              imageUrl = x.Image?.DownloadPath;
            }
          });
        }
      }

      if (!imageUrl)
        imageUrl = state.store?.info?.logoUri;

      return imageUrl;
    },

    storeName: (state, getters, rootState) => {
      let name = "";

      if (getters.storeInfo) name = getters.storeInfo.companyName;
      if (
        rootState.languageSelected &&
        rootState.languageSelected.storeName &&
        rootState.languageSelected.storeName != ""
      )
        name = rootState.languageSelected.storeName;

      if (rootState.appData?.type == "membership") {
        if (getters.storeLinked && Array.isArray(getters.storeLinked)) {
          getters.storeLinked.forEach(x => {
            if (x.type == "M" && x.name) name = x.name;
          });
        }
      }

      return name;
    },

    storeTimeZoneAbbrev: (state, getters) => {
      return getters.storeInfo && getters.storeInfo.timeZoneAbbrev ? getters.storeInfo.timeZoneAbbrev : "";
    },

    storeTimeZone: (state, getters) => {
      let timeZone = "America/Toronto";
      if (getters.storeInfo && getters.storeInfo.timeZone) {
        timeZone = getters.storeInfo.timeZone;
      }

      return timeZone;
    },

    storeTimeZoneMatched: (state, getters) => {
      if (getters.storeInfo && getters.storeInfo.timeZoneUtcOffsetMin) {
        let now = new Date();
        let deviceUtcOffsetMin = -now.getTimezoneOffset();
        return deviceUtcOffsetMin == getters.storeInfo.timeZoneUtcOffsetMin;
      } else return true;
    },

    storeTel: (state, getters) => {
      let tel = "";
      if (getters.storeInfo && getters.storeInfo.address) {
        let addr = getters.storeInfo.address;
        if (addr.tel && addr.tel != "") {
          tel = addr.tel;
        }
      }
      return tel;
    },

    storeAddress: (state, getters) => {
      let address = {};
      if (getters.storeInfo && getters.storeInfo.address) {
        address = getters.storeInfo.address;
      }
      return address;
    },

    storeOrderHttpServerUrl: (state, getters) => {
      return getters.storeInfo?.orderHttpServerUrl;
    },

    storeMealPrepMinutes: state => {
      if (state.store?.config?.pickupMin > 0) return state.store.config.pickupMin;
      else return 0;
    },

    storeOrderTypes: state => {
      if (state.store) return state.store.orderType;
      else return null;
    },

    storeOrderType: (state, getters) => orderType => {
      let om;
      if (getters.storeOrderTypes) {
        if (orderType == ORDER_TYPE.DINEIN) {
          om = getters.storeOrderTypes.dinein;
        } else if (orderType == ORDER_TYPE.TAKEOUT) {
          om = getters.storeOrderTypes.takeout;
        } else if (orderType == ORDER_TYPE.DELIVERY) {
          om = getters.storeOrderTypes.delivery;
        }
      }
      return om;
    },

    storeCovidContactFormUrl: state => {
      if (state.store?.config?.covidContactFormUrl)
        return state.store.config.covidContactFormUrl;
      else return "";
    },

    storeGTag: (state, getters) => {
      if (getters.storeConfig == null) return null;
      else return getters.storeConfig.gTag;
    },

    storeMenuMode: (state, getters, rootState) => {
      return rootState.Order.order.orderType == ORDER_TYPE.DINEIN && getters.storeDineinMenuMode === true;
    },

    storeDineinVisible: (state, getters) => {
      if (state.store?.config?.storeHome) {
        return state.store.config.storeHome.dinein && state.store.config.storeHome.dinein;
      } else if (getters.storeOrderTypes && getters.storeOrderTypes.dinein) {
        return getters.storeOrderTypes.dinein.hide !== true;
      } else return true;
    },

    storeDineinMenuMode: (state, getters) => {
      if (getters.storeOrderTypes && getters.storeOrderTypes.dinein) {
        return getters.storeOrderTypes.dinein.menuMode === true;
      } else return false;
    },

    storeDineinLogin: (state, getters) => {
      if (getters.storeOrderTypes && getters.storeOrderTypes.dinein) {
        return getters.storeOrderTypes.dinein.login;
      } else return "required";
    },

    storeDineinTotalHidden: (state, getters) => {
      if (getters.storeOrderTypes && getters.storeOrderTypes.dinein) {
        return getters.storeOrderTypes.dinein.hideOrderTotal === true;
      } else return false;
    },

    storeDineinPromotionEnabled: (state, getters) => {
      if (getters.storeOrderTypes && getters.storeOrderTypes.dinein) {
        return getters.storeOrderTypes.dinein.promotionEnabled === true;
      } else return false;
    },

    storeDineinAwayEnabled: (state, getters) => {
      if (getters.storeOrderTypes && getters.storeOrderTypes.dinein) {
        return getters.storeOrderTypes.dinein.takeAwayEnabled === true;
      } else return true;
    },

    storeDineinCallServiceEnabled: (state, getters, rootState) => {
      if (getters.storeOrderTypes && getters.storeOrderTypes.dinein) {
        return (
          getters.storeOrderTypes.dinein.callServiceEnabled === true &&
          getters.storeOrderTypes.dinein.callServices.length > 0 &&
          rootState.Order.order.tableID > 0
        );
      } else return true;
    },

    storeDineinCallServices: (state, getters) => {
      let _services = [];
      if (getters.storeOrderTypes && getters.storeOrderTypes.dinein) {
        _services = getters.storeOrderTypes.dinein.callServices;
      }

      return _services ? _services : [];
    },

    storeTakeoutVisible: (state, getters) => {
      if (state.store?.config?.storeHome) {
        return state.store.config.storeHome.takeout === true;
      } else if (getters.storeOrderTypes && getters.storeOrderTypes.takeout) {
        return getters.storeOrderTypes.takeout.hide !== true;
      } else return true;
    },

    storeDeliveryVisible: (state, getters) => {
      if (state.store?.config?.storeHome) {
        return state.store.config.storeHome.delivery && state.store.config.storeHome.delivery;
      } else if (getters.storeOrderTypes && getters.storeOrderTypes.delivery) {
        return getters.storeOrderTypes.delivery.hide !== true;
      } else return true;
    },

    storeWaitlistVisible: (state, getters) => {
      if (state.store?.config?.storeHome) {
        return getters.storeReserveEnabled && state.store.config.storeHome.waitlist === true;
      } else return getters.storeWaitlistEnabled;
    },

    storeReserveVisible: (state, getters) => {
      if (state.store?.config?.storeHome) {
        return getters.storeReserveEnabled && state.store.config.storeHome.reservation === true;
      } else return getters.storeReserveEnabled;
    },

    storeDineinAskTableName: (state, getters) => {
      if (getters.storeOrderTypes && getters.storeOrderTypes.dinein) {
        return getters.storeOrderTypes.dinein.askTableName === true;
      } else return false;
    },

    storeWaitlistEnabled: (state, getters) => {
      return getters.memberEnabled && getters.storeService && getters.storeService.waitlistEnabled === true;
    },

    storeReserveEnabled: (state, getters) => {
      return getters.memberEnabled && getters.storeService && getters.storeService.reserveEnabled === true;
    },

    storeBookingAppKey: (state, getters) => {
      return getters.storeService && getters.storeService.bookingAppKey;
    },

    paymentCurrency: (state, getters) => {
      if (
        getters.storeCheckout == null ||
        getters.storeCheckout.currency == null ||
        getters.storeCheckout.currency == ""
      )
        return "CAD";
      else return getters.storeCheckout.currency;
    },

    paymentDeposit: (state, getters) => {
      if (getters.storeCheckout) return getters.storeCheckout.deposit;
      else return null;
    },

    paymentTips: (state, getters, rootState) => {
      let tips = [];

      if (getters.paymentDeposit == null || getters.paymentDeposit.value == null || getters.paymentDeposit.value == 0) {
        if (getters.storeCheckout) {
          let _tips;
          if (rootState.Order.order.orderType == ORDER_TYPE.DELIVERY && getters.doorDashEnabled)
            _tips = getters.storeCheckout.doorDashTips;
          else _tips = getters.storeCheckout.tips;
          if (_tips == null) _tips = [];

          let tipsDefed = false;
          _tips.forEach(tipsEle => {
            let tipsTitle = "";
            let tipsDef = false;
            let tipsDollar = false;
            let tipsCustom = false;
            let tipsValue = 0;

            if (typeof tipsEle == "object") {
              tipsDef = tipsEle.default;
              tipsDollar = tipsEle.dollar;
              tipsCustom = tipsEle.custom;
              tipsValue = tipsEle.value;
            } else if (typeof tipsEle == "string") {
              let numMatch = tipsEle.match(rootState.numberPattern);
              if (numMatch && numMatch.length > 0) {
                tipsValue = Number(numMatch[0]);
              }

              tipsDef = !tipsDefed && tipsEle.includes("!");
              if (tipsDef) tipsDefed = true;

              tipsDollar = tipsEle.includes("$");
              tipsCustom = tipsEle.includes("*");
            } else if (typeof tipsEle == "number") tipsValue = tipsEle;

            if (tipsCustom) tipsTitle = "Other";
            else if (tipsDollar) tipsTitle = "$" + tipsValue.toString();
            else tipsTitle = tipsValue.toString() + "%";

            let tipsItem = {
              title: tipsTitle,
              value: tipsValue,
              rate: !tipsDollar,
              checked: tipsDef,
              other: tipsCustom,
            };
            tips.push(tipsItem);
          });

          if (tips.length > 0) {
            tips.unshift({
              title: "No Tips",
              value: 0,
              rate: true,
              checked: tipsDefed ? false : true,
              other: false,
            });
          }
        }
      }

      return tips;
    },

    // if distance is greater than the max distance in rule, the charge will be the charge in farest rule
    deliveryCharge: (state, getters) => distance => {
      let charge = 0;
      let ruleMax;
      if (
        getters.storeOrderTypes &&
        getters.storeOrderTypes.delivery &&
        getters.storeOrderTypes.delivery.chargeRules &&
        Array.isArray(getters.storeOrderTypes.delivery.chargeRules)
      ) {
        let chargeRules = getters.storeOrderTypes.delivery.chargeRules;
        chargeRules.forEach(rule => {
          if (rule.from < distance && rule.to >= distance) charge = rule.charge;
          if (ruleMax == null || rule.to > ruleMax.to) ruleMax = rule;
        });

        if (ruleMax && distance > ruleMax.to) charge = ruleMax.charge;
      }
      return charge;
    },

    deliveryMaxDistance: (state, getters) => {
      if (getters.storeOrderTypes == null) return 0;
      else return getters.storeOrderTypes.delivery.distance;
    },

    deliveryAgentEnabled: (state, getters) => {
      return getters.doorDashEnabled === true;
    },

    deliveryAgentAdjustment: (state, getters) => {
      let adjustment = { value: 0, byPercentage: false };
      if (getters.storeOrderTypes && getters.storeOrderTypes.delivery) {
        let otd = getters.storeOrderTypes.delivery;
        if (otd.agentAdjValue) adjustment.value = mUtils.toFloat(otd.agentAdjValue);
        adjustment.byPercentage = otd.agentAdjByPercentage === true;
      }
      return adjustment;
    },

    deliveryAgentAdjustedCharge: (state, getters) => value => {
      let charge = value;
      let adjustment = getters.deliveryAgentAdjustment;

      if (adjustment.byPercentage) {
        charge = charge * (1 + adjustment.value / 100);
      } else {
        charge += adjustment.value;
      }
      if (charge < 0) charge = 0;

      return charge;
    },

    deliveryAgentChargeOverwrited: (state, getters) => {
      let overwrited = false;
      if (getters.storeOrderTypes && getters.storeOrderTypes.delivery) {
        let otd = getters.storeOrderTypes.delivery;
        overwrited = otd.agentOverwrite === true;
      }
      return overwrited;
    },

    itemStockEnabled: (state, getters) => {
      return getters.storeInfo && getters.storeInfo.itemStockEnabled && getters.storeInfo.itemStockEnabled === true;
    },

    orderOptionsSortBySeq: (state, getters) => {
      return (
        getters.storeInfo && getters.storeInfo.orderOptionsSortBySeq && getters.storeInfo.orderOptionsSortBySeq === true
      );
    },

    orderLimitPerPeriod: (state, getters) => {
      if (getters.storeConfig == null || getters.storeConfig.orderLimitPerPeriod == null) return 0;
      else return getters.storeConfig.orderLimitPerPeriod;
    },

    orderLimitSkipValue: (state, getters) => {
      if (getters.storeConfig == null || getters.storeConfig.orderLimitSkipValue == null) return 0;
      else return getters.storeConfig.orderLimitSkipValue;
    },

    menuImageVisible: (state, getters) => {
      let value = "show";
      if (getters.storeConfig) {
        if (getters.storeConfig.menuImageVisible) {
          value = getters.storeConfig.menuImageVisible;
        } else if (getters.storeConfig.hideMenuImage) {
          value = getters.storeConfig.hideMenuImage ? "hide" : "show";
        }
      }
      return value;
    },

    ageVisible: () => {
      return true;
    },

    menuImageAlignment: (state, getters) => {
      if (getters.storeConfig == null || getters.storeConfig.menuImageAlignment == null) return "left";
      else return getters.storeConfig.menuImageAlignment;
    },

    menuPriceAlignment: (state, getters) => {
      if (getters.storeConfig.menuImageAlignment == "right") return "left";
      else return "right";
    },

    addShortcutBarEnabled: (state, getters) => {
      if (state.stores.list.length > 0) {
        return state.stores.addShortcutBarEnabled;
      } else if (getters.storeConfig && getters.storeConfig.addShortcutBarEnabled)
        return getters.storeConfig.addShortcutBarEnabled;
      else return false;
    },

    notCheckServerOnline: (state, getters) => {
      if (getters.storeConfig == null || getters.storeConfig.notCheckServerOnline == null) return false;
      else return getters.storeConfig.notCheckServerOnline;
    },

    itemFastAdd: (state, getters) => {
      if (getters.storeConfig == null || getters.storeConfig.itemFastAdd == null) return false;
      else return getters.storeConfig.itemFastAdd;
    },

    notAskUtensils: (state, getters) => {
      if (getters.storeConfig == null || getters.storeConfig.notAskUtensils == null) return false;
      else return getters.storeConfig.notAskUtensils;
    },

    utensils: (state, getters) => {
      /*
      if (getters.storeConfig == null || getters.storeConfig.utensils == null) return true;
      else return getters.storeConfig.utensils;
      */
      return getters.storeConfig?.utensils;
    },

    alwaysSendPickupTime: (state, getters) => {
      if (getters.storeConfig == null || getters.storeConfig.alwaysSendPickupTime == null) return false;
      else return getters.storeConfig.alwaysSendPickupTime;
    },

    memoAsBillMemo: (state, getters) => {
      if (getters.storeConfig == null || getters.storeConfig.memoAsBillMemo == null) return false;
      else return getters.storeConfig.memoAsBillMemo;
    },

    showItemBarcode: (state, getters) => {
      if (getters.storeConfig == null || getters.storeConfig.showItemBarcode == null) return false;
      else return getters.storeConfig.showItemBarcode;
    },

    addSideItemOptional: (state, getters) => {
      return getters.storeConfig?.addSideItemOptional === true;
    },

    showItemImageInOrder: (state, getters) => {
      if (getters.storeConfig == null || getters.storeConfig.showItemImageInOrder == null) return false;
      else return getters.storeConfig.showItemImageInOrder;
    },

    showOptionImageInOrder: (state, getters) => {
      if (Vue.prototype.$devEnv) return true;

      if (getters.storeConfig == null || getters.storeConfig.showOptionImageInOrder == null) return false;
      else return getters.storeConfig.showOptionImageInOrder;
    },

    verifyPhoneNumber: (state, getters) => {
      if (getters.storeConfig == null || getters.storeConfig.verifyPhoneNumber == null) return false;
      else return getters.storeConfig.verifyPhoneNumber;
    },

    merchants: state => {
      let n_merchants = null;
      if (state.store && state.store.checkout && state.store.checkout.merchants) {
        n_merchants = state.store.checkout.merchants;
      }

      return n_merchants;
    },

    stripeEnabled: (state, getters) => {
      let merchants = getters.merchants;
      return merchants && merchants.includes("stripe");
    },

    globalPaymentEnabled: (state, getters) => {
      let merchants = getters.merchants;
      return merchants && merchants.includes("globalPayment");
    },
  },

  mutations: {
    stores(state, payload) {
      if (payload.list) state.stores.list = payload.list;
      if (payload.sortBy) state.stores.sortBy = payload.sortBy;
      if (payload.header) state.stores.header = payload.header;
      if (payload.addShortcutBarEnabled) state.stores.addShortcutBarEnabled = payload.addShortcutBarEnabled;
    },

    store(state, payload) {
      state.store = payload;
    },
  },

  actions: {},
};
